// DNO abbreviations
export const UKPN = "UKPN"
export const NGED = "NGED"
export const SPEN = "SPEN"
export const NPG = "NPG"
export const ENWL = "ENWL"
export const SSEN = "SSEN"
export const NIE = "NIE"

// I-DNO Abbreviations
export const IESP = "I-ESP"
export const IUKPN = "I-UKPN"
export const IGTC = "I-GTC"
export const IMUAG = "I-MUAG"
export const IENAN = "I-ENAN"
export const IVTF = "I-VTF"
export const IEPN = "I-EPN"
export const IHEN = "I-HEN"
export const IUKPD = "I-UKPD"
export const ILEEP = "I-LEEP"
export const IIDCSL = "I-IDCSL"
export const IIDGO = "I-IDGO"
export const ILMUK = "I-LMUK"
export const IFEAL = "I-FEAL"
export const IHENL = "I-HENL"

export const NIE_ID = "81"

// Abbreviations prefixed "I:" are IDNOs
export const NETWORK_TO_DNO_ABBREVIATION_DISPATCHER = {
    "10": UKPN,
    "11": NGED,
    "12": UKPN,
    "13": SPEN,
    "14": NGED,
    "15": NPG,
    "16": ENWL,
    "17": SSEN,
    "18": SPEN,
    "19": UKPN,
    "20": SSEN,
    "21": NGED,
    "22": NGED,
    "23": NPG,
    "24": IGTC,
    "25": IESP,
    "26": ILMUK,
    "27": IGTC,
    "28": IUKPN,
    "29": IHENL,
    "30": ILEEP,
    "31": IUKPD,
    "32": IENAN,
    "33": IEPN,
    "34": IMUAG,
    "35": IFEAL,
    [NIE_ID]: NIE,
    "36": IVTF,
    "38": IIDGO,
    "43": IIDCSL,
}

// DNO display names
export const NETWORK_TO_DNO_FRIENDLY_ABBREVIATION_DISPATCHER = {
    [UKPN]: "UK Power Networks",
    [SSEN]: "Scottish and Southern Electricity Networks",
    [NGED]: "National Grid Electricity Distribution",
    [NIE]: "Northern Ireland Electricity Networks",
    [NPG]: "Northern Powergrid",
    [SPEN]: "SP Energy Networks",
    [ENWL]: "Electricity North West",
    [IESP]: "ESP Electricity Ltd",
    [IGTC]: "GTC Infrastructure",
    [IMUAG]: "MUA Electricity Limited",
    [IENAN]: "Energy Assets Network",
    [IVTF]: "Vattenfall Networks",
    [IEPN]: "Eclipse Power Networks Limited",
    [ILEEP]: "Leep Utilities",
    [ILMUK]: "Last Mile Electricity",
    [IUKPD]: "UK Power Distribution",
    [IIDGO]: "Indigo Networks",
    [IIDCSL]: "Independent Distribution Connection Specialists Ltd (IDCSL)",
    [IFEAL]: "Fulcrum Electricity Assets Ltd",
    [IHENL]: "Harlaxton Energy Networks Limited",
    "": "",
}
